import request from '@/api/config.js'

// Получение всех марок
export function getCarModel() {
  return request({
    url: `car-model`,
    method: 'get',
  })
}

// Добавление новой марки
export function createCarModel(data) {
  return request({
    url: `car-model/create`,
    method: 'post',
    data,
  })
}

// Обновление данных о марке
export function updateCarModel(data) {
  return request({
    url: `car-model/`,
    method: 'put',
    data,
  })
}

// Удаление марки по ID
export function deleteCarModel(id) {
  return request({
    url: `car-model/${id}`,
    method: 'delete',
  })
}
